import React, { PureComponent, useState } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import "./index.css";
import api from "../../Services/api";
import { FcSearch, FcPlus, FcFilledFilter } from "react-icons/fc";
import { AxiosResponse } from "axios";
import { Link } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

export class Child extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      tableData: [],
      orgtableData: [],
      perPage: 10,
      currentPage: 0,
      pagAtual: 1,
      length: 0,
      endpoint: this.props.endPoint,
      clicked: false,
      atualiza: 0,
      search: '',
      isChecked: [],
      consult: this.props.consult,
      forcePage: 0
    };

    this.handlePageClick = this.handlePageClick.bind(this);
  }



  handlePageClick = (e) => {
    const selectedPage = e.selected;
    const offset = selectedPage * this.state.perPage;

    this.setState(
      {
        currentPage: selectedPage,
        offset: offset,
        pagAtual: selectedPage + 1,
        forcePage: selectedPage
      },
      () => {
        this.loadMoreData();
      }
    );


  };

  loadMoreData() {

    const data = this.state.dataT;

    const slice = data.slice(
      this.state.offset,
      this.state.offset + this.state.perPage,

    );


    //////////////////////aqui
    this.setState({
      pageCount: Math.ceil(data.length / this.state.perPage),
      tableData: slice,
      length: data.length,
    });

  }


  handlePageClick_clear = () => {
    const selectedPage = 0;
    const offset = selectedPage * this.state.perPage;

    this.setState(
      {
        currentPage: selectedPage,
        offset: offset,
        pagAtual: selectedPage + 1,
        forcePage: selectedPage,
      },
      () => {
        this.loadMoreData();
      }
    );


  };




  handleInputChange = (event) => {
    this.setState({ search: event.target.value });
  };

  do_search = () => {

    this.setState({
      dataT: this.state.orgtableData,
    });
    //------------------------------BUSCAR
    if (this.state.search === '' || this.state.search === undefined || this.state.search === null) {

    } else {


      const temp_rows = this.state.orgtableData.filter(
        (e) => {
          return (
            JSON.stringify(e)
              .toLowerCase()
              .indexOf(this.state.search.toLowerCase()) >= 0
          );
        }
      );
      
      var slice = temp_rows.slice(
        this.state.offset,
        this.state.offset + this.state.perPage
      );

      this.setState({
        pageCount: Math.ceil(temp_rows.length / this.state.perPage),
        orgtableData: this.state.orgtableData,
        tableData: slice,
        dataT: temp_rows,
        length: temp_rows.length,
        pagAtual: 1,
      });

      this.handlePageClick_clear()
    }


  };

  clear_search = () => {
    //------------------------------LIMPAR
    this.setState({ search: '' });

    var slice = this.state.orgtableData.slice(
      this.state.offset,
      this.state.offset + this.state.perPage
    );

    this.setState({
      pageCount: Math.ceil(this.state.orgtableData.length / this.state.perPage),
      orgtableData: this.state.orgtableData,
      tableData: slice,
      dataT: this.state.orgtableData,
      length: this.state.orgtableData.length,
      pagAtual: 0,
      forcePage: 0,
    });

    this.handlePageClick_clear();

  };

  componentDidMount() {
    this.getData();
    this.clear_search();
  }

  getData() {
    if (this.props.ambiente !== null) {
      try {
        api.get(this.props.endPoint, {
          params: {
            ambiente: this.props.ambiente
          }
        }).then((res) => {
          var data = res.data.data;
          if (res.data.status === 200) {
            var slice = data.slice(
              this.state.offset,
              this.state.offset + this.state.perPage
            );

            this.setState({
              pageCount: Math.ceil(data.length / this.state.perPage),
              orgtableData: res.data.data,
              tableData: slice,
              dataT: res.data.data,
              length: data.length,
            });

          }
        });


      }
      catch (e) { 
        
      }
    }
  }


  toggle = (index) => {
    if (this.state.clicked === index) {
      //if clicked question is already active, then close it
      return this.setState({ clicked: null });
    }
    this.setState({ clicked: index });
  };

  handlecheckbox = (e) => {
    const { value, checked } = e.target;

    if (checked) {

      this.setState({
        isChecked: ([...this.state.isChecked, value])
      });
   

    } else {


      this.setState({
        isChecked: (this.state.isChecked.filter((e) => e !== value))
      });
     

    }

  }

  chamarCust = (valor) => {
    this.props.funtoggle(valor, this.props.form);

  }

  exibirFiltro = () => {
  
    if(this.state.clicked === true){
      this.setState({
        clicked: false
      });
    }else{
      this.setState({
        clicked: true
      });
    }
  }

  render() {
    return (
      <div className="ContainerGrid">
        <div className="ContainerBody">
            <div className="InputBusca">
              <input
                placeholder="Pesquisar..."
                onChange={this.handleInputChange}
                value={this.state.search}
              />

              <div className="icone-buscaT" onClick={this.do_search}>
                <FcSearch className="icone-add" />
              </div>

              <div className="icone-buscaT" onClick={this.clear_search}>
                <i className="fa-solid fa-eraser icone-add"></i>
              </div>
             
            </div>

            {secureLocalStorage.getItem('acp') === 'DESENVOLVEDOR' || secureLocalStorage.getItem('acp') === 'ADMINISTRADOR' ? (
              <Link to={this.props.fromAdd} className="icone-buscaAdd" >
                <FcPlus className="icone-add" />
              </Link>
             ) : null}

        </div>

        <div className="ContainerDropdown">
          {this.state.clicked === true ? (
            <div className="dropdown">
              <div className="user-filtro">
                <div className="input-box-grid">
                  <span className="details">Ativo</span>
                  <select id="SELCAT" name="SELCAT" key='CAT0'>
                    <option disabled selected>
                      {" "}
                      -- Selecione --{" "}
                    </option>
                  </select>
                </div>

                <div className="input-box-grid">
                  <span className="details">Categoria</span>
                  <select id="SELCAT" name="SELCAT" key='CAT1'>
                    <option disabled selected>
                      {" "}
                      -- Selecione --{" "}
                    </option>
                  </select>
                </div>

                <div className="input-box-grid">
                  <span className="details">Categoria</span>
                  <select id="SELCAT" name="SELCAT" key='CAT2'>
                    <option disabled selected>
                      {" "}
                      -- Selecione --{" "}
                    </option>
                  </select>
                </div>

                <div className="input-box-grid">
                  <span className="details">Categoria</span>
                  <select id="SELCAT" name="SELCAT" key='CAT3'>
                    <option disabled selected>
                      {" "}
                      -- Selecione --{" "}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          ) : null}
        </div>

        {this.state.pageCount > 0 ? (
          <div className="grid-tab-user">
            <table>
              <tbody>
                <tr id="grid-header">
                  <th className="Title">{this.props.th1}</th>
                  <th className="Title">{this.props.th2}</th>
                  <th className="Title">{this.props.th3}</th>
                  <th className="Title">{this.props.th4}</th>
                  <th className="Title">{this.props.th5}</th>
                  <th className="Title">{this.props.th6}</th>
                  <th className="Title">Ações</th>
                </tr>
              </tbody>
              <tbody>
                {this.state.tableData.map((tdata, i) => (
                  <tr className="TR-Coluna" key={Object.values(tdata)[0]}>
                     <td className="ColunaCheck-user" align="center"><input type='checkbox' checked={Object.values(tdata)[this.props.col1]} onChange={() => { }} /></td>
                    <td className="Coluna-id">{Object.values(tdata)[this.props.col2]}</td>
                    <td className="Coluna-descricao">{Object.values(tdata)[this.props.col3]}</td>
                    <td className="Coluna-padrao">{Object.values(tdata)[this.props.col4]}</td>

                    {this.props.btn === 'S' ? (
                      <td className="Coluna-btn"><h1 className="btn-grid-incl" onClick={() => { this.props.incluirInventario(Object(tdata.inc_id)) }}>Incluir ao inventário</h1></td>
                    ) :
                    <td className="Coluna-padrao">{Object.values(tdata)[this.props.col5]?.substring(8, 10)}/{Object.values(tdata)[this.props.col5]?.substring(5, 7)}/{Object.values(tdata)[this.props.col5]?.substring(0, 4)} {Object.values(tdata)[this.props.col6]?.substring(11, 16)}</td>}

                    <td className="Coluna-data">{Object.values(tdata)[this.props.col6]?.substring(8, 10)}/{Object.values(tdata)[this.props.col6]?.substring(5, 7)}/{Object.values(tdata)[this.props.col6]?.substring(0, 4)} {Object.values(tdata)[this.props.col6]?.substring(11, 16)}</td>
                    <td className="Coluna-icone-btn">
                    
                      
                        <Link to={this.props.fromEdit + '/' + Object.values(tdata)[0]}>
                          <i className="fa fa-pen icone-acao1"></i>
                        </Link>  
                        {this.props.btnDelete === 'N' ? (
                          null):                     
                        <i className="fa fa-trash-alt icone-acao2" onClick={() => { this.props.iconeExcluir(Object(tdata)) }}  ></i>
                        }
                      
                      {this.state.consult === 'S' ? (
                          <Link to={this.props.fromVisualizar + '/' + Object.values(tdata)[0]}>
                            <i className="fa fa-search icone-acao3"></i>
                          </Link> 
                        ) : null}
                        
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}
        <div className="ContainerPag">
          <div className="InlineContainery">

            {this.state.pageCount === null || this.state.pageCount === 0 ? (
              <div className="SemResut">
                <h2>
                  Nenhum resultado encontrado.
                </h2>
                <h2>
                  Página 1 de 1
                </h2>
              </div>
            ) : null}

            <div className="InputBusca">
              {this.state.pageCount > 0 ? (
                <div className="Quant">
                  <h2>
                    Página {this.state.pagAtual} de {this.state.pageCount}
                  </h2>
                </div>
              ) : null}

              {this.state.pageCount > 1 ? (
                <ReactPaginate
                  previousLabel={<i className="fas fa-angle-left"></i>}
                  nextLabel={<i className="fas fa-angle-right"></i>}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={this.state.pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                  forcePage={this.state.forcePage}
                />
              ) : null}
            </div>
          </div>
          {this.state.pageCount > 0 ? (
            <div className="paginate">
              <h2>Total de registros: {this.state.length}</h2>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default Child;
